const menus = [
  {
    icon: 'clock-circle',
    title: '待派发订单',
    path: '/'
  },
  {
    icon: 'check-circle',
    title: '已匹配订单',
    path: '/completeTrip'
  },
  {
    icon: 'close-circle',
    title: '已取消订单',
    path: '/cancelTrip'
  },
  {
    icon: 'team',
    title: '用户管理',
    children: [
      {
        title: '小程序用户',
        path: '/appletUser'
      },
      {
        title: '管理员',
        path: '/administrator'
      }
    ]
  },
  {
    icon: 'flag',
    title: '班次管理',
    path: '/model/frequency'
  },
  {
    icon: 'setting',
    title: '小程序配置',
    path: '/setting'
  }
]
export default menus
